import type Mithril from 'mithril';
import Component from 'flarum/common/Component';
import Discussion from 'flarum/common/models/Discussion';
import icon from 'flarum/common/helpers/icon';

export interface DiscussionSubsAttrs {
  discussion: Discussion;
}

export default class DiscussionSubs extends Component<DiscussionSubsAttrs> {
  view(vnode: Mithril.Vnode<DiscussionSubsAttrs, this>) {
    const { discussion } = this.attrs;

    const states = {
      none: { label: '关注', icon: 'fas fa-star', save: 'follow' },
      follow: { label: '取消关注', icon: 'far fa-star', save: null },
      ignore: { label: '取消忽视', icon: 'fas fa-eye', save: null },
    };

    const subscription = discussion.subscription?.() || 'none';

    const state = states[subscription] || states.none;

    return (
      <span className="DiscussionListItem-action" onclick={discussion.save.bind(discussion, { subscription: state.save })}>
        {icon(state.icon)}
        <span>{state.label}</span>
      </span>
    );
  }
}
